import React from "react";
import { Link } from "react-router-dom";
import LoginPage from "../Login/LoginPage";
import {
  Card,
  Space,
  Typography,
  Button,
} from "antd";
import { isLogged } from "../../helpers/account";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const { Title, Text } = Typography;

function AccountPage() {
  const { t } = useTranslation();
  
  if (isLogged()) {
    const menuItems = [
      {
        key: "address-data",
        label: t('dashboard.account.accountBookkeepingData'),
        description: t('dashboard.account.managePersonalData'),
        link: "/account/data",
        icon: "👤"
      },
    ];

    return (
      <>
        <Helmet>
          <title>{t('dashboard.account.title')}</title>
        </Helmet>
        
        <div style={{ background: "#f8f9fa", minHeight: "100vh", padding: "40px 20px" }}>
          <div style={{ maxWidth: "800px", margin: "0 auto" }}>
            {/* Header */}
            <div style={{ marginBottom: "32px" }}>
              <Title level={2} style={{ margin: 0, color: "#2c3e50" }}>
                {t('dashboard.account.accountData')}
              </Title>
              <Text style={{ color: "#6c757d", fontSize: "16px" }}>
                {t('dashboard.account.manageAccount')}
              </Text>
            </div>

            {/* Menu Items */}
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              {menuItems.map((item) => (
                <Card
                  key={item.key}
                  style={{
                    border: "none",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    borderRadius: "12px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                  hoverable
                  onClick={() => window.location.href = item.link}
                >
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                      <div style={{ fontSize: "32px" }}>{item.icon}</div>
                      <div>
                        <Title level={4} style={{ margin: 0, color: "#2c3e50" }}>
                          {item.label}
                        </Title>
                        <Text style={{ color: "#6c757d", fontSize: "14px" }}>
                          {item.description}
                        </Text>
                      </div>
                    </div>
                    <ArrowRightOutlined style={{ color: "#667eea", fontSize: "16px" }} />
                  </div>
                </Card>
              ))}

              {/* Help Card */}
              <Card 
                title={`💡 ${t('dashboard.account.tip')}`}
                style={{ 
                  borderRadius: "12px", 
                  border: "none", 
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)", 
                  background: "#f8f9fa" 
                }}
              >
                <Text style={{ color: "#6c757d", fontSize: "14px", lineHeight: "1.6" }}>
                  {t('dashboard.account.keepDataUpdated')}
                </Text>
              </Card>
            </Space>
          </div>
        </div>
      </>
    );
  } else {
    return <LoginPage />;
  }
}

export default AccountPage;